module.exports = __webpack_public_path__ + "static/assets/b3df5d66157a11580d041221eb239a8e.png";